import { Grid as UiGrid } from '@creditas-ui/layout'
import { styled } from '@creditas-ui/system'

const BaseGridItem = styled(UiGrid)``

export { BaseGridItem }
